import { APIContextProvider } from 'context/APIContext'
import { ActiveWorkoutContextProvider } from 'context/ActiveWorkoutContext'
import { AdminContextProvider } from 'context/AdminContext'
import { OrganizationBillingContextProvider } from 'context/OrganizationBillingContext'
import { ProgramContextProvider } from 'context/ProgramContext'
import { TrainingCalendarContextProvider } from 'context/TrainingCalendarContext'

export default function MasterContextProvider({ children }) {
    return (
        <APIContextProvider>
            <ActiveWorkoutContextProvider>
                <AdminContextProvider>
                    <OrganizationBillingContextProvider>
                        <ProgramContextProvider>
                            <TrainingCalendarContextProvider>
                                {children}
                            </TrainingCalendarContextProvider>
                        </ProgramContextProvider>
                    </OrganizationBillingContextProvider>
                </AdminContextProvider>
            </ActiveWorkoutContextProvider>
        </APIContextProvider>
    )
}